import {frontend} from 'pageflow-scrolled/frontend';

import {Footer} from './Footer';

frontend.widgetTypes.register('handelsblattPaywallFooter', {
  component: Footer
});
